import { Component } from '@angular/core';
import { Platform, NavController } from '@ionic/angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConexionApiService } from './conexion-api.service';
import { UpdateService } from './services/update.service';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { environment } from '../environments/environment';
import { AfterViewInit } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { AyudaComponent } from './modals/ayuda/ayuda.component';

import { Plugins} from '@capacitor/core';

const {Storage} = Plugins;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements AfterViewInit{
  telefono:any = environment.contacto.wsp;
  texto_contacto:any = environment.contacto.texto;
  telefonocall:any = "tel:" + environment.contacto.telefonocall;
  flag_ayuda: any = "";

  constructor(
    private platform: Platform,
    private device: DeviceDetectorService,
    private nav: NavController,
    public api: ConexionApiService,
    public sw: UpdateService,
    public router: Router,
    private locationStrategy : LocationStrategy,
    public modalController: ModalController
  ) {

    // block back button 
    this.preventBackButton();

    //  evitar install banner 
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
    });

    this.sw.checkForUpdates();
    // con esta funcion me aseguro de verificar que esté
    //  en un mobile durante toda la app
    if (this.device.isDesktop()) {
      this.nav.navigateRoot('/browser');
    } else {
      this.initializeApp();
    }
    // debug viewport

    let overlay:HTMLElement = document.createElement('div');
    Storage.set({
      key: 'flag_ayuda', 
      value: "0"
    });

    //this.api.presentToast("DPR:" +window.devicePixelRatio + " RES:" + window.innerWidth + "x" + window.innerHeight, 5);
  }

  ngAfterViewInit() {
    const btn = document.getElementById('floatcall');
    if (!btn) return;

    // Posición inicial
    btn.style.bottom = '80px';
    btn.style.right = '24px';
    btn.style.left = 'auto';
    btn.style.top = 'auto';

    let offsetX = 0, offsetY = 0, startX = 0, startY = 0, dragging = false;

    btn.addEventListener('pointerdown', (e: PointerEvent) => {
      dragging = true;
      btn.setPointerCapture(e.pointerId);
      startX = e.clientX;
      startY = e.clientY;
      const rect = btn.getBoundingClientRect();
      offsetX = startX - rect.left;
      offsetY = startY - rect.top;
      btn.style.cursor = 'grabbing';
    });

    window.addEventListener('pointermove', (e: PointerEvent) => {
      if (!dragging) return;
      const btnRect = btn.getBoundingClientRect();
      const parentWidth = window.innerWidth;
      const parentHeight = window.innerHeight;

      let x = e.clientX - offsetX;
      let y = e.clientY - offsetY;

      // Limitar dentro de la ventana
      x = Math.max(0, Math.min(x, parentWidth - btnRect.width));
      y = Math.max(0, Math.min(y, parentHeight - btnRect.height));

      btn.style.left = x + 'px';
      btn.style.top = y + 'px';
      btn.style.right = 'auto';
      btn.style.bottom = 'auto';
    });

    window.addEventListener('pointerup', () => {
      dragging = false;
      btn.style.cursor = 'grab';
    });
  }

  async AyudaModal() {
    this.flag_ayuda = await Storage.get({ key: 'flag_ayuda' });
    console.log(this.flag_ayuda.value);
    
    if (this.flag_ayuda.value == null || this.flag_ayuda.value == "0") {
      await Storage.set({
        key: 'flag_ayuda', 
        value: "1"
      });
      const modal = await this.modalController.create({
        component: AyudaComponent,
        componentProps: {}
      });
      return await modal.present();
    } else {
      await Storage.set({
        key: 'flag_ayuda', 
        value: "0"
      });
      const closeModal: string = "Modal Closed";
      await this.modalController.dismiss(closeModal);
    }
  }

  public ayudaWhatsappButton(){
    this.api.btnWspAyuda();
  }

  public preventBackButton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    })
  }

  initializeApp() {
    // show app... don't touch
    this.platform.ready().then(() => {
      console.log("ready");
    });
  }
}